import { render } from "./CookieBanner.vue?vue&type=template&id=748cd4b7&scoped=true&ts=true"
import script from "./CookieBanner.vue?vue&type=script&lang=ts"
export * from "./CookieBanner.vue?vue&type=script&lang=ts"

import "./CookieBanner.vue?vue&type=style&index=0&id=748cd4b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748cd4b7"]])

export default __exports__